export default __webpack_public_path__ + "static/media/tools.9e7e31bd.svg";